
let setCourseData = (data:any) => {
  localStorage.setItem("myPatCourse",JSON.stringify(data));
    let setCourseData = (data: any) => ({ type: 'SET_COURSE_DATA', data });
    return (dispatch: any) => {
      dispatch(setCourseData(data));
    }
}

let setFilterValue = (data:any) => {
  
  let setCourseData = (data: any) => ({ type: 'SET_FILTER_VALUE', data });
  return (dispatch: any) => {
    dispatch(setCourseData(data));
  }
}

export {
    setCourseData,
    setFilterValue
}